import { render, staticRenderFns } from "./OrderInformationComponent.vue?vue&type=template&id=1abf410f&"
import script from "./OrderInformationComponent.vue?vue&type=script&lang=js&"
export * from "./OrderInformationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports